import React from 'react';
import IconContainer from './icon_container';

export default props => (
  <IconContainer viewBox="0 0 16 13" {...props}>
    <path
      className="twitterIcon"
      d="M13.736 2.94c.118-.205.213-.428.28-.664l.253-.87-.756.5c-.356.237-.74.412-1.14.52-.47-.48-1.095-.758-1.758-.758-1.438 0-2.588 1.287-2.588 2.857 0 .068.002.137.006.205-1.572-.206-3-1.09-4-2.464l-.315-.432-.25.473c-.223.428-.343.918-.343 1.425 0 .502.12.983.334 1.404l-.35-.216v.626c0 .834.327 1.597.855 2.125L3.76 7.63l.153.53c.25.872.86 1.55 1.627 1.84-.607.37-1.292.57-2.003.57-.165 0-.33-.01-.496-.032l-1.295-.16 1.06.76c1.084.777 2.34 1.196 3.655 1.196 3.972 0 6.75-3.527 6.75-7.514l-.003-.174c.42-.362.785-.798 1.08-1.29l.576-.97-1.01.5c-.04.02-.078.04-.117.056z"
      strokeWidth=".665"
      fill="none"
      fillRule="evenodd"
    />
  </IconContainer>
);



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/icons/twitter_icon.jsx